import { render, staticRenderFns } from "./VsModal.vue?vue&type=template&id=2c917ed9&lang=pug&"
import script from "./VsModal.vue?vue&type=script&lang=js&"
export * from "./VsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c917ed9')) {
      api.createRecord('2c917ed9', component.options)
    } else {
      api.reload('2c917ed9', component.options)
    }
    module.hot.accept("./VsModal.vue?vue&type=template&id=2c917ed9&lang=pug&", function () {
      api.rerender('2c917ed9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsModal.vue"
export default component.exports